module.exports = __webpack_public_path__ + "assets1662726319812/img/lan4.5dcca9c1.png";